import { Route } from '@angular/router';
import { RoutePath } from '@univacity/shared/types';

export const pagesRoute: Route[] = [
  {
    path: RoutePath.solutionsStudent.replace('/', ''),
    loadComponent: () =>
      import('./for-students/for-students.component').then(
        (c) => c.ForStudentsComponent
      ),
    data: { transparent: true, fullWidth: true },
  },
  {
    path: RoutePath.solutionsRecruiters.replace('/', ''),
    loadComponent: () =>
      import('./for-recruiters/for-recruiters.component').then(
        (c) => c.ForRecruitersComponent
      ),
    data: { transparent: true, fullWidth: true },
  },
  {
    path: RoutePath.solutionsInstitutes.replace('/', ''),
    loadComponent: () =>
      import('./for-institutes/for-institutes.component').then(
        (c) => c.ForInstitutesComponent
      ),
    data: { transparent: true, fullWidth: true },
  },
  {
    path: RoutePath.policy.replace('/', ''),
    loadComponent: () =>
      import('./privacy-policy/privacy-policy.component').then(
        (c) => c.PrivacyPolicyComponent
      ),
  },
  {
    path: RoutePath.terms.replace('/', ''),
    loadComponent: () =>
      import('./terms-of-service/terms-of-service.component').then(
        (c) => c.TermsOfServiceComponent
      ),
  },
  {
    path: RoutePath.cookiePolicy.replace('/', ''),
    loadComponent: () =>
      import('./cookie-policy/cookie-policy.component').then(
        (c) => c.CookiePolicyComponent
      ),
  },
  {
    path: RoutePath.refundPolicy.replace('/', ''),
    loadComponent: () =>
      import('./refund-policy/refund-policy.component').then(
        (c) => c.RefundPolicyComponent
      ),
  },
  {
    path: RoutePath.contact.replace('/', ''),
    loadComponent: () =>
      import('./contact/contact.component').then((c) => c.ContactComponent),
    data: { transparent: true, fullWidth: true },
  },
  {
    path: RoutePath.referralCode.replace('/', '') + '/:id',
    loadChildren: () => import('../home/home.module').then((m) => m.HomeModule),
  },
  {
    path: RoutePath.error.replace('/', ''),
    loadComponent: () =>
      import('../pages/error/error.component').then((m) => m.ErrorComponent),
    data: { fullWidth: true },
  },
];
